(() => {
  // Load Shopify's product-aware recommendations on product pages.
  document.querySelectorAll('[data-product-recommendations][data-url]').forEach(async (section) => {
    try {
      const response = await fetch(section.dataset.url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const replacement = parsed.getElementById(section.id);
      const grid = replacement?.querySelector('.product-grid');
      if (!grid) return;
      section.querySelector('.container').innerHTML = replacement.querySelector('.container').innerHTML;
      section.hidden = false;
    } catch {
      // Recommendations are optional; keep the product page usable if they fail.
    }
  });

  // Accessibility Focus Trap Utility
  const trapFocus = (container, event) => {
    if (event.key !== 'Tab') return;
    const focusables = Array.from(
      container.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.offsetParent !== null || el.offsetWidth > 0 || el.offsetHeight > 0);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  const drawer = document.querySelector('[data-cart-drawer]');

  // Mobile menu keyboard handling and focus management
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mobileMenu) {
    const summary = mobileMenu.querySelector('summary');
    const nav = mobileMenu.querySelector('nav');
    mobileMenu.addEventListener('toggle', () => {
      if (summary) {
        summary.setAttribute('aria-expanded', mobileMenu.open ? 'true' : 'false');
      }
      if (mobileMenu.open && nav) {
        // Focus first link when menu opens
        const firstLink = nav.querySelector('a');
        if (firstLink) firstLink.focus();
      }
    });
    // Close on Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileMenu.open) {
        mobileMenu.open = false;
        if (summary) summary.focus();
      }
    });
    // Close when clicking outside
    document.addEventListener('click', (event) => {
      if (mobileMenu.open && !mobileMenu.contains(event.target)) {
        mobileMenu.open = false;
      }
    });
  }

  // Shop dropdown menu keyboard handling and click-outside
  const shopDropdown = document.querySelector('[data-shop-dropdown]');
  if (shopDropdown) {
    const shopSummary = shopDropdown.querySelector('summary');
    shopDropdown.addEventListener('toggle', () => {
      if (shopSummary) {
        shopSummary.setAttribute('aria-expanded', shopDropdown.open ? 'true' : 'false');
      }
      if (shopDropdown.open) {
        const firstItem = shopDropdown.querySelector('.shop-dropdown-item');
        if (firstItem) firstItem.focus();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && shopDropdown.open) {
        shopDropdown.open = false;
        if (shopSummary) shopSummary.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (shopDropdown.open && !shopDropdown.contains(event.target)) {
        shopDropdown.open = false;
      }
    });
  }
  const cartContent = document.querySelector('[data-cart-content]');
  const countNodes = document.querySelectorAll('[data-cart-count], [data-drawer-count]');
  const cartButtons = document.querySelectorAll('[data-cart-open]');
  const root = window.Shopify?.routes?.root || '/';
  const moneyFormat = window.Shopify?.money_format || '${{amount}}';

  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', String(Math.round(Number(cents || 0) / 100)));
  };

  const updateCount = (count) => {
    countNodes.forEach((node) => {
      node.textContent = node.matches('[data-drawer-count]') ? `(${count})` : count;
    });
    cartButtons.forEach((button) => {
      button.setAttribute('aria-label', `Open cart, ${count} item${count !== 1 ? 's' : ''}`);
    });
    // Also update the cart button's text content for any screen-reader live regions
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.setAttribute('aria-live', 'polite');
      node.setAttribute('aria-atomic', 'true');
    });
  };

  const shippingBarNodes = document.querySelectorAll('[data-shipping-bar]');
  const drawerSubtotal = document.querySelector('[data-drawer-subtotal]');
  const drawerShippingEstimate = document.querySelector('[data-drawer-shipping-estimate]');
  const drawerDiscounts = document.querySelector('[data-drawer-discounts]');
  const drawerTotal = document.querySelector('[data-drawer-total]');
  const drawerUpsells = document.querySelector('[data-drawer-upsells]');
  const cartFooter = document.querySelector('[data-cart-footer]');

  const updateShippingBars = (totalPrice) => {
    shippingBarNodes.forEach((bar) => {
      const threshold = bar.dataset.threshold !== undefined ? Number(bar.dataset.threshold) : 0;
      const text = bar.querySelector('[data-shipping-text]');
      const progress = bar.querySelector('[data-shipping-progress]');
      if (!text || !progress) return;
      if (threshold === 0 || totalPrice >= threshold) {
        bar.classList.add('unlocked');
        progress.style.width = '100%';
        text.innerHTML = '🎉 <strong>You\'ve unlocked FREE US Shipping on All Orders!</strong>';
      } else {
        bar.classList.remove('unlocked');
        const remaining = threshold - totalPrice;
        const pct = Math.max(5, Math.min(100, Math.round((totalPrice / threshold) * 100)));
        progress.style.width = `${pct}%`;
        text.innerHTML = `Add <strong>${formatMoney(remaining)}</strong> more for <strong>FREE Shipping!</strong> 🚚`;
      }
    });
  };

  const renderCart = (cart) => {
    if (!cartContent) return;
    updateCount(cart.item_count);
    updateShippingBars(cart.total_price);
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);

    if (drawerShippingEstimate) {
      drawerShippingEstimate.innerHTML = '<strong class="text-success">FREE</strong>';
    }

    if (drawerDiscounts) {
      if (cart.total_discount > 0) {
        drawerDiscounts.parentElement.hidden = false;
        drawerDiscounts.textContent = `-${formatMoney(cart.total_discount)}`;
      } else {
        drawerDiscounts.parentElement.hidden = true;
      }
    }

    if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);

    // Filter upsell cards based on current cart contents
    const upsellCards = document.querySelectorAll('[data-upsell-card]');
    let visibleUpsells = 0;
    upsellCards.forEach((card) => {
      const cardVariantId = card.dataset.variantId;
      const alreadyInCart = cart.items.some((item) => String(item.variant_id) === String(cardVariantId));
      if (alreadyInCart) {
        card.style.display = 'none';
      } else {
        card.style.display = 'flex';
        visibleUpsells++;
      }
    });
    if (drawerUpsells) {
      drawerUpsells.style.display = visibleUpsells > 0 ? '' : 'none';
    }

    cartContent.replaceChildren();

    if (cart.items.length === 0) {
      if (cartFooter) cartFooter.classList.add('drawer-footer--empty');
      const emptyState = document.createElement('div');
      emptyState.className = 'drawer-empty-state';
      emptyState.innerHTML = `
        <div class="drawer-empty-paw" aria-hidden="true">🐾</div>
        <p class="drawer-empty-title">Your cart is waiting for a good dog find.</p>
        <a class="button button--primary drawer-empty-btn" href="${root}collections/all">Explore Dog Essentials</a>
      `;
      cartContent.append(emptyState);
      return;
    }

    if (cartFooter) cartFooter.classList.remove('drawer-footer--empty');

    cart.items.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'drawer-line';
      row.dataset.lineKey = item.key;

      if (item.image) {
        const imgLink = document.createElement('a');
        imgLink.href = item.url;
        imgLink.className = 'drawer-line-thumb';
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title || '';
        image.loading = 'lazy';
        image.width = 72;
        image.height = 72;
        imgLink.append(image);
        row.append(imgLink);
      }

      const details = document.createElement('div');
      details.className = 'drawer-line-details';

      const title = document.createElement('a');
      title.href = item.url;
      title.className = 'drawer-line-title';
      title.textContent = item.product_title;
      details.append(title);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('div');
        variant.className = 'drawer-line-variant';
        variant.textContent = item.variant_title;
        details.append(variant);
      }

      const actionsRow = document.createElement('div');
      actionsRow.className = 'drawer-line-actions';

      const stepper = document.createElement('div');
      stepper.className = 'drawer-stepper';
      stepper.innerHTML = `
        <button type="button" class="drawer-qty-btn" data-qty-action="minus" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity for ${item.product_title}">−</button>
        <span class="drawer-qty-val">${item.quantity}</span>
        <button type="button" class="drawer-qty-btn" data-qty-action="plus" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity for ${item.product_title}">+</button>
      `;
      actionsRow.append(stepper);

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'drawer-remove-btn';
      removeBtn.dataset.removeKey = item.key;
      removeBtn.setAttribute('aria-label', `Remove ${item.product_title}`);
      removeBtn.textContent = 'Remove';
      actionsRow.append(removeBtn);

      details.append(actionsRow);

      const priceCol = document.createElement('div');
      priceCol.className = 'drawer-line-price';
      if (item.original_line_price > item.final_line_price) {
        const originalPrice = document.createElement('s');
        originalPrice.textContent = formatMoney(item.original_line_price);
        priceCol.append(originalPrice);
      }
      const priceVal = document.createElement('strong');
      priceVal.textContent = formatMoney(item.final_line_price);
      priceCol.append(priceVal);

      row.append(details, priceCol);
      cartContent.append(row);
    });
  };

  const changeCartItem = async (key, quantity) => {
    if (!cartContent) return;
    cartContent.classList.add('loading');
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      renderCart(cart);
    } catch {
      await loadCart();
    } finally {
      cartContent.classList.remove('loading');
    }
  };

  const loadCart = async () => {
    if (!cartContent) return;
    cartContent.textContent = 'Loading your cart…';
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart could not be loaded');
      const cart = await response.json();
      renderCart(cart);
    } catch {
      cartContent.textContent = 'Your cart is ready to view.';
    }
  };

  // Delegate cart quantity and remove clicks in drawer
  cartContent?.addEventListener('click', (event) => {
    const qtyBtn = event.target.closest('[data-qty-action]');
    if (qtyBtn) {
      event.preventDefault();
      const key = qtyBtn.dataset.key;
      const newQty = parseInt(qtyBtn.dataset.qty, 10);
      changeCartItem(key, newQty);
      return;
    }
    const removeBtn = event.target.closest('[data-remove-key]');
    if (removeBtn) {
      event.preventDefault();
      const key = removeBtn.dataset.removeKey;
      changeCartItem(key, 0);
    }
  });

  // 1-Click Drawer Upsell Add Handler
  document.addEventListener('click', async (event) => {
    const upsellBtn = event.target.closest('[data-drawer-upsell-add]');
    if (!upsellBtn) return;
    event.preventDefault();
    const variantId = upsellBtn.dataset.drawerUpsellAdd;
    if (!variantId || upsellBtn.disabled) return;

    upsellBtn.disabled = true;
    const originalHtml = upsellBtn.innerHTML;
    upsellBtn.innerHTML = '<span>Adding…</span>';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!response.ok) throw new Error('Could not add item');
      upsellBtn.innerHTML = '<span>✓ Added</span>';
      await loadCart();
    } catch {
      upsellBtn.disabled = false;
      upsellBtn.innerHTML = originalHtml;
    }
  });

  let drawerPreviousFocus = null;
  drawer?.addEventListener('keydown', (event) => {
    trapFocus(drawer, event);
    if (event.key === 'Escape') {
      drawer.close();
    }
  });
  drawer?.addEventListener('close', () => {
    if (drawerPreviousFocus && drawerPreviousFocus.focus) {
      drawerPreviousFocus.focus();
      drawerPreviousFocus = null;
    }
  });

  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (!drawer) return;
      if (drawer.open) {
        drawer.close();
      } else {
        drawerPreviousFocus = button;
        drawer.showModal();
        const closeBtn = drawer.querySelector('[data-cart-close]');
        if (closeBtn) closeBtn.focus();
        await loadCart();
      }
    });
  });
  document.querySelector('[data-cart-close]')?.addEventListener('click', () => drawer?.close());
  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) drawer.close();
  });

  const openCartDrawer = async () => {
    if (!drawer) return;
    if (!drawer.open) {
      drawer.showModal();
      const closeBtn = drawer.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    }
    await loadCart();
  };
  window.addEventListener('paws:cart:open', openCartDrawer);

  // Cart page (/cart) quantity steppers and form handling
  const cartForm = document.getElementById('CartForm');
  if (cartForm) {
    cartForm.addEventListener('click', (event) => {
      const minusBtn = event.target.closest('[data-qty-minus]');
      const plusBtn = event.target.closest('[data-qty-plus]');
      if (!minusBtn && !plusBtn) return;
      event.preventDefault();
      const line = (minusBtn || plusBtn).closest('.cart-line');
      const input = line?.querySelector('[data-qty-input]');
      if (!input) return;
      let val = parseInt(input.value, 10) || 0;
      if (minusBtn) {
        val = Math.max(0, val - 1);
      } else if (plusBtn) {
        val = val + 1;
      }
      input.value = val;
      const updateBtn = cartForm.querySelector('[name="update"]');
      if (updateBtn) {
        updateBtn.click();
      } else {
        cartForm.submit();
      }
    });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    let variants = [];
    try { variants = JSON.parse(form.dataset.variants || '[]'); } catch { /* Keep standard form behavior if variant data is unavailable. */ }
    const select = form.querySelector('[data-variant-select]');
    const price = document.querySelector('.product-price');
    const availability = form.querySelector('[data-availability]');
    const submit = form.querySelector('[name="add"]');
    const stickyBtn = document.querySelector('[data-sticky-add-to-cart-btn]');
    const stickyBar = document.querySelector('[data-sticky-bar]');
    const stickyVariantTitle = document.querySelector('[data-sticky-variant-title]');
    const stickyPrice = document.querySelector('[data-sticky-price]');

    const refreshVariant = () => {
      const variant = variants.find((item) => String(item.id) === String(select?.value));
      if (!variant) return;
      if (price) {
        price.replaceChildren();
        if (variant.compare_at_price > variant.price) {
          const compare = document.createElement('s');
          compare.textContent = formatMoney(variant.compare_at_price);
          price.append(compare);
        }
        const current = document.createElement('span');
        current.textContent = formatMoney(variant.price);
        price.append(current);
      }
      if (availability) availability.textContent = variant.available ? 'Available to add to cart.' : 'Currently unavailable.';
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (stickyVariantTitle) {
        stickyVariantTitle.textContent = variant.title !== 'Default Title' ? variant.title : '';
      }
      if (stickyPrice) {
        stickyPrice.replaceChildren();
        if (variant.compare_at_price > variant.price) {
          const compare = document.createElement('s');
          compare.textContent = formatMoney(variant.compare_at_price);
          stickyPrice.append(compare);
        }
        const current = document.createElement('span');
        current.textContent = formatMoney(variant.price);
        stickyPrice.append(current);
      }
      // Switch main product image to match the selected variant
      const mainImage = document.querySelector('#ProductMediaMain img');
      const mediaNodes = document.querySelectorAll('[data-media-position]');
      if (mainImage && mediaNodes.length && variant.position != null) {
        const target = document.querySelector(`[data-media-position="${variant.position}"]`);
        if (target && target !== mainImage.parentElement) {
          const img = target.querySelector('img');
          if (img) {
            mainImage.src = img.src;
            mainImage.alt = img.alt || mainImage.alt;
          }
        }
        // Sync thumbnail active tab state
        document.querySelectorAll('.product-thumb').forEach((thumb) => {
          const isMatch = String(thumb.dataset.mediaPosition) === String(variant.position);
          thumb.classList.toggle('active', isMatch);
          thumb.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });
      }
      window.dispatchEvent(new CustomEvent('paws:variant:change', { detail: { variant, price: variant.price } }));
    };
    select?.addEventListener('change', refreshVariant);

    // Swatch & Size pill interactions
    const picker = form.querySelector('[data-variant-picker]');
    if (picker) {
      const swatchInputs = picker.querySelectorAll('[data-swatch-input]');
      swatchInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const group = input.closest('.variant-option-group');
          const labelVal = group?.querySelector('[data-selected-value]');
          if (labelVal) labelVal.textContent = input.value;

          const groupName = input.name;
          picker.querySelectorAll(`input[name="${groupName}"]`).forEach((radio) => {
            radio.closest('label')?.classList.toggle('active', radio.checked);
          });

          // Match variant from selected options
          const selectedOptions = Array.from(picker.querySelectorAll('[data-swatch-input]:checked')).map((r) => r.value);
          const matching = variants.find((v) => {
            const m1 = !v.option1 || v.option1 === selectedOptions[0];
            const m2 = !v.option2 || v.option2 === selectedOptions[1];
            const m3 = !v.option3 || v.option3 === selectedOptions[2];
            return m1 && m2 && m3;
          });

          if (matching && select) {
            select.value = matching.id;
            select.dispatchEvent(new Event('change'));
            try {
              const newUrl = new URL(window.location.href);
              newUrl.searchParams.set('variant', matching.id);
              window.history.replaceState({}, '', newUrl.toString());
            } catch {}
          }
        });
      });
    }

    // Sticky add-to-cart IntersectionObserver
    if (stickyBar && submit) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('visible');
            stickyBar.setAttribute('aria-hidden', 'false');
            stickyBar.removeAttribute('inert');
          } else {
            stickyBar.classList.remove('visible');
            stickyBar.setAttribute('aria-hidden', 'true');
            stickyBar.setAttribute('inert', '');
          }
        });
      }, { threshold: 0 });
      observer.observe(submit);
    }

    form.addEventListener('submit', async (event) => {
      if (!drawer || !window.fetch) return;
      event.preventDefault();
      if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Could not add item');
        if (drawer && !drawer.open) drawer.showModal();
        await loadCart();
      } catch {
        form.submit();
        return;
      } finally {
        if (submit) {
          submit.disabled = false;
          const currentVariant = variants.find((item) => String(item.id) === String(select?.value));
          submit.textContent = currentVariant && currentVariant.available ? 'Add to cart' : 'Sold out';
          submit.disabled = !currentVariant || !currentVariant.available;
        }
      }
    });

    // Sticky add-to-cart bar: trigger the main form submission
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        if (submit && !submit.disabled) {
          submit.click();
        }
      });
    }
  });

  // Size Guide Modal
  const sizeModal = document.querySelector('[data-size-modal]');
  const sizeModalOpenBtns = document.querySelectorAll('[data-size-modal-open]');
  const sizeModalCloseBtn = document.querySelector('[data-size-modal-close]');
  let sizeModalPreviousFocus = null;

  sizeModal?.addEventListener('keydown', (event) => {
    trapFocus(sizeModal, event);
    if (event.key === 'Escape') sizeModal.close();
  });

  sizeModalOpenBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!sizeModal) return;
      sizeModalPreviousFocus = document.activeElement;
      sizeModal.showModal();
      if (sizeModalCloseBtn) sizeModalCloseBtn.focus();
    });
  });

  sizeModalCloseBtn?.addEventListener('click', () => sizeModal?.close());
  sizeModal?.addEventListener('click', (event) => {
    if (event.target === sizeModal) sizeModal.close();
  });
  sizeModal?.addEventListener('close', () => {
    if (sizeModalPreviousFocus && sizeModalPreviousFocus.focus) {
      sizeModalPreviousFocus.focus();
      sizeModalPreviousFocus = null;
    }
  });

  const quickViewDialog = document.querySelector('[data-quick-view-dialog]');
  const quickViewBody = document.querySelector('[data-quick-view-body]');
  let quickViewPreviousFocus = null;

  quickViewDialog?.addEventListener('keydown', (event) => {
    trapFocus(quickViewDialog, event);
    if (event.key === 'Escape') quickViewDialog.close();
  });
  document.querySelector('[data-quick-view-close]')?.addEventListener('click', () => quickViewDialog?.close());
  quickViewDialog?.addEventListener('click', (event) => {
    if (event.target === quickViewDialog) quickViewDialog.close();
  });
  quickViewDialog?.addEventListener('close', () => {
    if (quickViewPreviousFocus && quickViewPreviousFocus.focus) {
      quickViewPreviousFocus.focus();
      quickViewPreviousFocus = null;
    }
  });

  // Delegated Quick View handler for both static cards and dynamic cards (recommendations / recently viewed)
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-quick-view]');
    if (!trigger) return;
    event.preventDefault();
    if (!quickViewDialog || !quickViewBody) return;

    quickViewPreviousFocus = trigger;
    quickViewBody.textContent = 'Loading product…';
    quickViewDialog.setAttribute('aria-labelledby', 'QuickViewTitle');
    quickViewDialog.showModal();

    const closeBtn = quickViewDialog.querySelector('[data-quick-view-close]');
    if (closeBtn) closeBtn.focus();

    try {
      const response = await fetch(`${root}products/${encodeURIComponent(trigger.dataset.quickView)}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product details could not be loaded');
      const product = await response.json();
      quickViewBody.replaceChildren();
      const image = document.createElement('img');
      image.className = 'quick-view-image';
      image.src = product.featured_image || product.images?.[0] || '';
      image.alt = product.title;
      const details = document.createElement('div');
      details.className = 'quick-view-details';
      const title = document.createElement('h2');
      title.id = 'QuickViewTitle';
      title.textContent = product.title;
      quickViewDialog.setAttribute('aria-labelledby', 'QuickViewTitle');
      const price = document.createElement('p');
      price.className = 'price';
      const priceFor = (variant) => formatMoney(variant?.price);
      const variantSelect = document.createElement('select');
      variantSelect.setAttribute('aria-label', 'Choose an option');
      product.variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = `${variant.title} — ${priceFor(variant)}${variant.available ? '' : ' — Sold out'}`;
        option.disabled = !variant.available;
        if (variant.id === product.variants.find((item) => item.available)?.id) option.selected = true;
        variantSelect.append(option);
      });
      const quantityLabel = document.createElement('label');
      quantityLabel.textContent = 'Quantity';
      const quantity = document.createElement('input');
      quantity.type = 'number';
      quantity.min = '1';
      quantity.value = '1';
      quantity.inputMode = 'numeric';
      quantityLabel.append(quantity);
      const addButton = document.createElement('button');
      addButton.className = 'button';
      addButton.type = 'button';
      const selectedVariant = () => product.variants.find((variant) => String(variant.id) === variantSelect.value);
      const updateQuickViewVariant = () => {
        const variant = selectedVariant();
        price.textContent = priceFor(variant);
        addButton.disabled = !variant?.available;
        addButton.textContent = variant?.available ? 'Add to cart' : 'Sold out';
        if (variant?.featured_image?.src) image.src = variant.featured_image.src;
      };
      variantSelect.addEventListener('change', updateQuickViewVariant);
      addButton.addEventListener('click', async () => {
        const variant = selectedVariant();
        if (!variant?.available) return;
        addButton.disabled = true;
        addButton.textContent = 'Adding…';
        try {
          const formData = new FormData();
          formData.set('id', variant.id);
          formData.set('quantity', String(Math.max(1, Number(quantity.value) || 1)));
          const addResponse = await fetch(`${root}cart/add.js`, { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
          if (!addResponse.ok) throw new Error('Could not add item');
          quickViewDialog.close();
          if (drawer && !drawer.open) drawer.showModal();
          await loadCart();
        } catch {
          addButton.textContent = 'Could not add — try product page';
        } finally {
          addButton.disabled = false;
        }
      });
      const productLink = document.createElement('a');
      productLink.className = 'quick-view-link';
      productLink.href = product.url;
      productLink.textContent = 'View full details';
      details.append(title, price);
      if (product.variants.length > 1 || product.variants[0]?.title !== 'Default Title') details.append(variantSelect);
      details.append(quantityLabel, addButton, productLink);
      quickViewBody.append(image, details);
      updateQuickViewVariant();
    } catch {
      quickViewBody.textContent = 'Could not load product details. Please open the product page.';
    }
  });

  // Product thumbnail gallery
  document.querySelectorAll('.product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const pos = thumb.dataset.mediaPosition;
      const mainMedia = document.querySelector('#ProductMediaMain');
      if (!mainMedia || !pos) return;
      const target = document.querySelector(`[data-media-position="${pos}"]`);
      if (target) {
        const img = target.querySelector('img, video');
        const mainImg = mainMedia.querySelector('img, video');
        if (img && mainImg) {
          mainImg.src = img.src;
          if (img.alt) mainImg.alt = img.alt;
        }
      }
      document.querySelectorAll('.product-thumb').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.currentTarget.value);
    window.location.assign(url.toString());
  });

  // Upgraded Predictive Search with rich previews, quick tags & clear button
  const searchPop = document.querySelector('[data-search-pop]');
  if (searchPop) {
    const searchInput = searchPop.querySelector('[data-predictive-search]');
    const clearBtn = searchPop.querySelector('[data-search-clear]');

    // Auto-focus input when search pop opens
    searchPop.addEventListener('toggle', () => {
      if (searchPop.open && searchInput) {
        window.setTimeout(() => searchInput.focus(), 80);
      }
    });

    // Close on Escape
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchPop.open) {
        searchPop.open = false;
        searchPop.querySelector('summary')?.focus();
      }
    });

    // Close when clicking outside
    document.addEventListener('click', (event) => {
      if (searchPop.open && !searchPop.contains(event.target)) {
        searchPop.open = false;
      }
    });

    // Quick tag chips
    searchPop.querySelectorAll('[data-search-tag]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const query = btn.dataset.searchTag;
        if (!searchInput || !query) return;
        searchInput.value = query;
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        searchInput.focus();
      });
    });

    // Clear button
    clearBtn?.addEventListener('click', () => {
      if (!searchInput) return;
      searchInput.value = '';
      clearBtn.hidden = true;
      const results = searchPop.querySelector('[data-predictive-results]');
      if (results) results.replaceChildren();
      searchInput.focus();
    });
  }

  document.querySelectorAll('[data-predictive-search]').forEach((input) => {
    const form = input.closest('form');
    const results = form?.querySelector('[data-predictive-results]');
    const clearBtn = form?.querySelector('[data-search-clear]');
    if (!results) return;

    results.setAttribute('aria-live', 'polite');
    results.setAttribute('aria-atomic', 'true');
    results.setAttribute('role', 'status');

    // Announcer for screen readers
    const announcer = document.createElement('span');
    announcer.className = 'visually-hidden';
    announcer.setAttribute('aria-live', 'polite');
    announcer.setAttribute('aria-atomic', 'true');
    form.insertBefore(announcer, results);

    let timer;
    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const term = input.value.trim();

      if (clearBtn) {
        clearBtn.hidden = term.length === 0;
      }

      if (term.length < 2) {
        results.replaceChildren();
        results.removeAttribute('aria-label');
        announcer.textContent = '';
        return;
      }

      results.setAttribute('aria-label', `Searching for ${term}…`);
      announcer.textContent = `Searching for ${term}…`;

      timer = window.setTimeout(async () => {
        try {
          const url = `${root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          const data = await response.json();
          const products = data.resources?.results?.products || [];
          results.replaceChildren();

          if (products.length === 0) {
            results.setAttribute('aria-label', `No results found for ${term}`);
            announcer.textContent = `No results found for ${term}`;
            const emptyNotice = document.createElement('div');
            emptyNotice.className = 'predictive-empty';
            emptyNotice.innerHTML = `No products found for "<strong>${term.replace(/</g, '&lt;')}</strong>". Try searching for <em>harness</em>, <em>leash</em>, or <em>bottle</em>.`;
            results.append(emptyNotice);
            return;
          }

          results.setAttribute('aria-label', `${products.length} result${products.length !== 1 ? 's' : ''} found for ${term}`);
          announcer.textContent = `${products.length} result${products.length !== 1 ? 's' : ''} found for ${term}`;

          const list = document.createElement('ul');
          list.className = 'predictive-results-list';
          list.setAttribute('role', 'list');

          products.forEach((product) => {
            const item = document.createElement('li');
            item.className = 'predictive-item';

            const link = document.createElement('a');
            link.href = product.url;
            link.className = 'predictive-link';

            // Thumbnail
            const thumbWrap = document.createElement('div');
            thumbWrap.className = 'predictive-thumb';
            if (product.image) {
              const img = document.createElement('img');
              img.src = product.image;
              img.alt = '';
              img.width = 44;
              img.height = 44;
              img.loading = 'lazy';
              thumbWrap.append(img);
            } else {
              const icon = document.createElement('span');
              icon.className = 'predictive-thumb-paw';
              icon.textContent = '🐾';
              thumbWrap.append(icon);
            }

            // Info
            const info = document.createElement('div');
            info.className = 'predictive-info';

            const title = document.createElement('span');
            title.className = 'predictive-title';
            title.textContent = product.title;

            const price = document.createElement('span');
            price.className = 'predictive-price';
            if (product.price) {
              const numPrice = Number(product.price);
              price.textContent = isNaN(numPrice) ? product.price : formatMoney(Math.round(numPrice * 100));
            }

            info.append(title, price);
            link.append(thumbWrap, info);
            item.append(link);
            list.append(item);
          });

          // Footer link
          const footerWrap = document.createElement('div');
          footerWrap.className = 'predictive-footer';
          const footerLink = document.createElement('a');
          footerLink.href = `${root}search?q=${encodeURIComponent(term)}&options[prefix]=last`;
          footerLink.className = 'predictive-view-all';
          footerLink.textContent = `View all results for "${term}" →`;
          footerWrap.append(footerLink);

          results.append(list, footerWrap);
        } catch {
          results.replaceChildren();
          results.setAttribute('aria-label', 'Search results could not be loaded');
          announcer.textContent = 'Search results could not be loaded';
        }
      }, 160);
    });
  });

  // Countdown Timer
  function updateCountdown() {
    document.querySelectorAll('[data-countdown-end]').forEach((element) => {
      const endTime = new Date(element.dataset.countdownEnd).getTime();
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance < 0) {
        element.innerHTML = '<div class="countdown-expired">Offer Expired</div>';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const daysEl = element.querySelector('[data-days]');
      const hoursEl = element.querySelector('[data-hours]');
      const minutesEl = element.querySelector('[data-minutes]');
      const secondsEl = element.querySelector('[data-seconds]');

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    });
  }

  // Recently Viewed Products
  const RECENTLY_VIEWED_KEY = 'paws_recently_viewed';
  const MAX_RECENTLY_VIEWED = 5;

  function addToRecentlyViewed(productId, productTitle, productImage, productPrice, productUrl) {
    let recentlyViewed = [];
    try {
      const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
      if (stored) {
        recentlyViewed = JSON.parse(stored);
      }
    } catch (e) {}

    if (!productId || !productTitle || !productUrl) return;
    const filtered = recentlyViewed.filter((item) => item.id !== productId);

    // Add to front
    recentlyViewed.unshift({
      id: productId,
      title: productTitle,
      image: productImage,
      price: productPrice,
      url: productUrl
    });

    // Keep only MAX_RECENTLY_VIEWED
    recentlyViewed = recentlyViewed.slice(0, MAX_RECENTLY_VIEWED);

    try {
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(recentlyViewed));
    } catch (e) {}
  }

  function renderRecentlyViewed() {
    const container = document.getElementById('recently-viewed-products');
    if (!container) return;

    let recentlyViewed = [];
    try {
      const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
      if (stored) {
        recentlyViewed = JSON.parse(stored);
      }
    } catch (e) {}

    const grid = container.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const safeProducts = recentlyViewed.filter((product) => {
      try {
        const url = new URL(product.url, window.location.origin);
        return url.origin === window.location.origin && url.pathname.startsWith('/products/');
      } catch {
        return false;
      }
    });
    if (safeProducts.length === 0) return;

    grid.replaceChildren();
    safeProducts.forEach((product) => {
      const card = document.createElement('article');
      card.className = 'product-card';
      const link = document.createElement('a');
      link.className = 'product-card-media';
      link.href = product.url;
      link.setAttribute('aria-label', product.title);
      if (product.image) {
        try {
          const imageUrl = new URL(product.image, window.location.origin);
          if (imageUrl.protocol === 'https:') {
            const image = document.createElement('img');
            image.src = imageUrl.href;
            image.alt = '';
            image.width = 600;
            image.height = 600;
            image.loading = 'lazy';
            link.append(image);
          }
        } catch {
          // A missing or malformed image doesn't prevent the product link rendering.
        }
      }
      const info = document.createElement('div');
      info.className = 'product-card-info';
      const title = document.createElement('a');
      title.href = product.url;
      title.className = 'product-title';
      title.textContent = product.title;
      const price = document.createElement('div');
      price.className = 'price';
      const priceText = document.createElement('span');
      priceText.textContent = product.price || '';
      price.append(priceText);
      info.append(title, price);
      card.append(link, info);
      grid.append(card);
    });
    container.hidden = false;
  }

  // Dog Fit & Breed Matcher Interactive Quiz
  const initDogFitFinder = () => {
    const finder = document.querySelector('[data-dog-fit-finder]');
    if (!finder) return;

    let sizeChoice = null;
    let styleChoice = null;

    const steps = {
      1: finder.querySelector('[data-finder-step="1"]'),
      2: finder.querySelector('[data-finder-step="2"]'),
      3: finder.querySelector('[data-finder-step="3"]')
    };
    const progressBar = finder.querySelector('[data-finder-progress]');
    const backBtn = finder.querySelector('[data-finder-back]');
    const restartBtn = finder.querySelector('[data-finder-restart]');

    const sizeHeadline = finder.querySelector('[data-results-size]');
    const sizeTip = finder.querySelector('[data-results-tip]');
    const productsBox = finder.querySelector('[data-results-products]');
    const ctaLink = finder.querySelector('[data-results-cta-link]');

    const sizeData = {
      small: {
        label: 'Small Pup',
        size: 'Size Small (Chest: 14 – 22 in / 36 – 56 cm)',
        tip: '<svg class="tip-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18h6"></path><path d="M10 22h4"></path><path d="M12 2a7 7 0 0 0-7 7c0 3 2 5.5 3 7h8c1-1.5 3-4 3-7a7 7 0 0 0-7-7z"></path></svg> <strong>Fit Tip:</strong> Ideal for French Bulldogs, Pugs, Dachshunds, and Yorkies with dual-adjust neck and chest straps to prevent slipping.',
        badge: 'Small Dog Fit'
      },
      medium: {
        label: 'Medium Dog',
        size: 'Size Medium (Chest: 20 – 28 in / 51 – 71 cm)',
        tip: '<svg class="tip-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18h6"></path><path d="M10 22h4"></path><path d="M12 2a7 7 0 0 0-7 7c0 3 2 5.5 3 7h8c1-1.5 3-4 3-7a7 7 0 0 0-7-7z"></path></svg> <strong>Fit Tip:</strong> Tailored for Corgis, Beagles, Border Collies, and Aussies with balanced front & back leash clip points.',
        badge: 'Medium Dog Fit'
      },
      large: {
        label: 'Large / XL Dog',
        size: 'Size Large / XL (Chest: 26 – 36 in / 66 – 91 cm)',
        tip: '<svg class="tip-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18h6"></path><path d="M10 22h4"></path><path d="M12 2a7 7 0 0 0-7 7c0 3 2 5.5 3 7h8c1-1.5 3-4 3-7a7 7 0 0 0-7-7z"></path></svg> <strong>Fit Tip:</strong> Built for Golden Retrievers, Labradors, German Shepherds, and Boxers with reinforced haul handle and chest plate.',
        badge: 'Large Dog Fit'
      }
    };

    const styleData = {
      daily: {
        title: 'Everyday Walking Routine',
        collectionUrl: `${root}collections/walking`,
        products: [
          {
            name: 'Vest-Style No-Pull Dog Harness',
            badge: 'Essential',
            desc: 'Dual clip rings, cushioned air-mesh comfort for pull-free strolls.'
          },
          {
            name: 'Everyday Soft-Grip PVC Leash',
            badge: 'Best Paired',
            desc: 'Comfort loop handle with dirt-resistant waterproof finish.'
          }
        ]
      },
      adventure: {
        title: 'Outdoor & Trail Adventures',
        collectionUrl: `${root}collections/walking`,
        products: [
          {
            name: 'Waterproof PVC Heavy-Duty Leash',
            badge: 'Mud & Odor Proof',
            desc: 'Rinse-clean in seconds, heavy-duty alloy hardware for rugged trails.'
          },
          {
            name: 'Vest-Style All-Weather Harness',
            badge: 'Rugged Fit',
            desc: 'Reflective trim for high visibility and quick-grab emergency top handle.'
          }
        ]
      },
      travel: {
        title: 'Travel & Road Safety',
        collectionUrl: `${root}collections/travel-safety`,
        products: [
          {
            name: 'Crash-Tested Canine Car Safety Harness',
            badge: 'Travel Must-Have',
            desc: 'Universal seatbelt tether clip, padded chest plate, zero distraction driving.'
          },
          {
            name: 'Portable Silicone Folding Pet Water Bottle',
            badge: 'Road Trip Essential',
            desc: 'One-touch water release with folding drinking trough, zero leak.'
          }
        ]
      },
      grooming: {
        title: 'Post-Adventure Bath & Spa Care',
        collectionUrl: `${root}collections/grooming`,
        products: [
          {
            name: 'Silicone Pet Shampoo Massager Brush',
            badge: 'Coat Care',
            desc: 'Gentle silicone bristles dispense lather deep into thick or short fur.'
          },
          {
            name: 'Quick-Dry Microfiber Paw Towel',
            badge: 'Fast Absorb',
            desc: 'Locks in mud and moisture after rainy park walks.'
          }
        ]
      }
    };

    const setStep = (stepNum) => {
      Object.keys(steps).forEach((num) => {
        if (steps[num]) {
          const isActive = Number(num) === stepNum;
          steps[num].classList.toggle('active', isActive);
          if (isActive) steps[num].removeAttribute('hidden');
          else steps[num].setAttribute('hidden', '');
        }
      });

      if (progressBar) {
        const progressPcts = { 1: '33%', 2: '66%', 3: '100%' };
        progressBar.style.width = progressPcts[stepNum] || '33%';
      }
    };

    const renderResults = () => {
      const selectedSize = sizeData[sizeChoice] || sizeData.medium;
      const selectedStyle = styleData[styleChoice] || styleData.daily;

      if (sizeHeadline) sizeHeadline.textContent = selectedSize.size;
      if (sizeTip) sizeTip.innerHTML = selectedSize.tip;

      if (productsBox) {
        productsBox.replaceChildren();
        selectedStyle.products.forEach((prod) => {
          const card = document.createElement('div');
          card.className = 'results-product-item';

          const badge = document.createElement('span');
          badge.className = 'results-item-badge';
          badge.textContent = prod.badge;

          const title = document.createElement('h5');
          title.className = 'results-item-title';
          title.textContent = prod.name;

          const desc = document.createElement('p');
          desc.className = 'results-item-desc';
          desc.textContent = prod.desc;

          card.append(badge, title, desc);
          productsBox.append(card);
        });
      }

      if (ctaLink) {
        ctaLink.href = selectedStyle.collectionUrl;
        ctaLink.textContent = `Shop ${selectedSize.label} ${selectedStyle.title} →`;
      }
    };

    // Step 1: Size options
    finder.querySelectorAll('[data-size-choice]').forEach((btn) => {
      btn.addEventListener('click', () => {
        sizeChoice = btn.dataset.sizeChoice;
        finder.querySelectorAll('[data-size-choice]').forEach((b) => b.classList.remove('selected'));
        btn.classList.add('selected');
        setStep(2);
      });
    });

    // Step 2: Style options
    finder.querySelectorAll('[data-style-choice]').forEach((btn) => {
      btn.addEventListener('click', () => {
        styleChoice = btn.dataset.styleChoice;
        finder.querySelectorAll('[data-style-choice]').forEach((b) => b.classList.remove('selected'));
        btn.classList.add('selected');
        renderResults();
        setStep(3);
      });
    });

    // Back button
    backBtn?.addEventListener('click', () => {
      setStep(1);
    });

    // Restart button
    restartBtn?.addEventListener('click', () => {
      sizeChoice = null;
      styleChoice = null;
      finder.querySelectorAll('.finder-option-btn').forEach((b) => b.classList.remove('selected'));
      setStep(1);
    });

    // Initial state
    setStep(1);
  };

  // Announcement Bar Slider
  const initAnnouncementBar = () => {
    const bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    const slides = Array.from(bar.querySelectorAll('[data-announcement-slide]'));
    if (slides.length <= 1) {
      bar.querySelectorAll('[data-announcement-prev], [data-announcement-next]').forEach((btn) => {
        btn.style.display = 'none';
      });
      return;
    }

    let currentIndex = slides.findIndex((slide) => slide.classList.contains('active'));
    if (currentIndex < 0) currentIndex = 0;
    const speed = Number(bar.dataset.speed) || 4500;
    let timer = null;
    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const showSlide = (nextIndex) => {
      slides[currentIndex].classList.remove('active');
      slides[currentIndex].setAttribute('aria-hidden', 'true');
      currentIndex = (nextIndex + slides.length) % slides.length;
      slides[currentIndex].classList.add('active');
      slides[currentIndex].removeAttribute('aria-hidden');
    };

    const nextSlide = () => showSlide(currentIndex + 1);
    const prevSlide = () => showSlide(currentIndex - 1);

    const startTimer = () => {
      if (prefersReducedMotion) return;
      stopTimer();
      timer = setInterval(nextSlide, speed);
    };

    const stopTimer = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    bar.querySelector('[data-announcement-prev]')?.addEventListener('click', () => {
      prevSlide();
      startTimer();
    });

    bar.querySelector('[data-announcement-next]')?.addEventListener('click', () => {
      nextSlide();
      startTimer();
    });

    bar.addEventListener('mouseenter', stopTimer);
    bar.addEventListener('mouseleave', startTimer);
    bar.addEventListener('focusin', stopTimer);
    bar.addEventListener('focusout', startTimer);

    // Initial setup
    slides.forEach((slide, idx) => {
      if (idx !== currentIndex) {
        slide.classList.remove('active');
        slide.setAttribute('aria-hidden', 'true');
      } else {
        slide.classList.add('active');
        slide.removeAttribute('aria-hidden');
      }
    });

    startTimer();
  };

  // 1. Canine Breed & Size Fit Guide on Collection Pages
  const initCanineFitFilter = () => {
    const filterBar = document.querySelector('[data-canine-fit-filter]');
    const grid = document.querySelector('[data-collection-product-grid]');
    if (!filterBar || !grid) return;

    const sizePills = filterBar.querySelectorAll('[data-filter-size]');
    const stagePills = filterBar.querySelectorAll('[data-filter-stage]');
    const statusRow = filterBar.querySelector('[data-fit-status-row]');
    const statusText = filterBar.querySelector('[data-fit-status-text]');
    const clearBtn = filterBar.querySelector('[data-fit-clear]');
    const cards = Array.from(grid.querySelectorAll('.product-card'));

    let activeSize = 'all';
    let activeStage = 'all';

    const applyFilter = () => {
      let matchCount = 0;

      cards.forEach((card) => {
        const rawSizes = (card.dataset.canineSizes || '').toLowerCase();
        const rawStages = (card.dataset.canineStages || '').toLowerCase();
        const cardSizes = rawSizes ? rawSizes.split(',').map((s) => s.trim()) : [];
        const cardStages = rawStages ? rawStages.split(',').map((s) => s.trim()) : [];

        // Match size: if activeSize is 'all' or card has no size restriction or includes activeSize
        const matchesSize =
          activeSize === 'all' ||
          cardSizes.length === 0 ||
          cardSizes.includes(activeSize) ||
          (activeSize === 'toy' && cardSizes.includes('small'));

        // Match stage: if activeStage is 'all' or card has no stage restriction or includes activeStage
        const matchesStage =
          activeStage === 'all' ||
          cardStages.length === 0 ||
          cardStages.includes(activeStage);

        const isMatch = matchesSize && matchesStage;
        if (isMatch) {
          card.style.display = '';
          card.removeAttribute('hidden');
          matchCount++;
        } else {
          card.style.display = 'none';
          card.setAttribute('hidden', '');
        }
      });

      // Update feedback row
      const isFiltered = activeSize !== 'all' || activeStage !== 'all';
      if (isFiltered && statusRow && statusText) {
        statusRow.style.display = '';
        const sizeLabels = {
          toy: 'Toy (<10 lbs)',
          small: 'Small (10–25 lbs)',
          medium: 'Medium (25–55 lbs)',
          large: 'Large (55–80 lbs)',
          giant: 'Giant (80+ lbs)'
        };
        const stageLabels = {
          puppy: 'Puppy',
          adult: 'Adult',
          senior: 'Senior'
        };

        const sizePart = activeSize !== 'all' ? sizeLabels[activeSize] || activeSize : '';
        const stagePart = activeStage !== 'all' ? stageLabels[activeStage] || activeStage : '';
        const filterSummary = [sizePart, stagePart].filter(Boolean).join(' • ');

        statusText.textContent = `Showing ${matchCount} ${matchCount === 1 ? 'item' : 'items'} for ${filterSummary}`;
      } else if (statusRow) {
        statusRow.style.display = 'none';
      }

      // Sync URL search params
      const url = new URL(window.location);
      if (activeSize !== 'all') url.searchParams.set('dog_size', activeSize);
      else url.searchParams.delete('dog_size');

      if (activeStage !== 'all') url.searchParams.set('life_stage', activeStage);
      else url.searchParams.delete('life_stage');

      window.history.replaceState(null, '', url.toString());
    };

    sizePills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const sizeVal = pill.dataset.filterSize;
        activeSize = sizeVal;
        sizePills.forEach((p) => {
          const isActive = p === pill;
          p.classList.toggle('active', isActive);
          p.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
        applyFilter();
      });
    });

    stagePills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const stageVal = pill.dataset.filterStage;
        activeStage = stageVal;
        stagePills.forEach((p) => {
          const isActive = p === pill;
          p.classList.toggle('active', isActive);
          p.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
        applyFilter();
      });
    });

    clearBtn?.addEventListener('click', () => {
      activeSize = 'all';
      activeStage = 'all';
      sizePills.forEach((p) => {
        const isAll = p.dataset.filterSize === 'all';
        p.classList.toggle('active', isAll);
        p.setAttribute('aria-checked', isAll ? 'true' : 'false');
      });
      stagePills.forEach((p) => {
        const isAll = p.dataset.filterStage === 'all';
        p.classList.toggle('active', isAll);
        p.setAttribute('aria-checked', isAll ? 'true' : 'false');
      });
      applyFilter();
    });

    // Fit Guide Modal handling
    const guideModal = document.querySelector('[data-canine-fit-modal]');
    const guideTrigger = filterBar.querySelector('[data-canine-guide-open]');
    const guideClose = guideModal?.querySelector('[data-canine-modal-close]');

    if (guideModal && guideTrigger) {
      let previousFocus = null;

      guideTrigger.addEventListener('click', () => {
        previousFocus = guideTrigger;
        guideModal.showModal();
        guideClose?.focus();
      });

      guideClose?.addEventListener('click', () => {
        guideModal.close();
      });

      guideModal.addEventListener('keydown', (e) => {
        trapFocus(guideModal, e);
        if (e.key === 'Escape') guideModal.close();
      });

      guideModal.addEventListener('close', () => {
        if (previousFocus && previousFocus.focus) previousFocus.focus();
      });

      guideModal.addEventListener('click', (e) => {
        if (e.target === guideModal) guideModal.close();
      });
    }

    // Read initial URL params
    const params = new URLSearchParams(window.location.search);
    const initialSize = params.get('dog_size');
    const initialStage = params.get('life_stage');

    if (initialSize) {
      const matchPill = filterBar.querySelector(`[data-filter-size="${initialSize}"]`);
      if (matchPill) matchPill.click();
    }
    if (initialStage) {
      const matchPill = filterBar.querySelector(`[data-filter-stage="${initialStage}"]`);
      if (matchPill) matchPill.click();
    }
  };

  // 2. Bundle & Save Builder ("Pick 3 Items and Save 15%")
  const initBundleBuilder = () => {
    const section = document.querySelector('[data-bundle-builder]');
    if (!section) return;

    const targetCount = parseInt(section.dataset.bundleTarget, 10) || 3;
    const discountPct = parseInt(section.dataset.bundleDiscount, 10) || 15;

    const progressBar = section.querySelector('[data-bundle-progress-fill]');
    const tierBadge = section.querySelector('[data-bundle-tier-badge]');
    const statusMsg = section.querySelector('[data-bundle-status-msg]');
    const slotSteps = section.querySelectorAll('.bundle-slot-step');

    const dock = section.querySelector('[data-bundle-dock]');
    const dockSlots = section.querySelectorAll('[data-dock-slot]');
    const originalPriceEl = section.querySelector('[data-bundle-original-price]');
    const finalPriceEl = section.querySelector('[data-bundle-final-price]');
    const savingsPill = section.querySelector('[data-bundle-savings-pill]');
    const submitBtn = section.querySelector('[data-bundle-submit]');
    const submitBtnText = section.querySelector('[data-bundle-btn-text]');

    let selectedItems = []; // Array of { productId, variantId, price, title, image }

    const updateBundleUI = () => {
      const count = selectedItems.length;
      const pct = Math.min((count / targetCount) * 100, 100);

      // Progress bar fill
      if (progressBar) progressBar.style.width = `${pct}%`;

      // Status messages
      if (tierBadge) {
        tierBadge.textContent = count >= targetCount ? 'Tier Unlocked!' : `Step ${count + 1} of ${targetCount}`;
      }

      if (statusMsg) {
        if (count === 0) {
          statusMsg.textContent = `Select ${targetCount} items to unlock your ${discountPct}% Pack Discount`;
        } else if (count < targetCount) {
          const needed = targetCount - count;
          statusMsg.textContent = `Almost there! Pick ${needed} more ${needed === 1 ? 'item' : 'items'} to save ${discountPct}%`;
        } else {
          statusMsg.textContent = `🎉 ${discountPct}% Bundle Discount Unlocked! Added savings will apply in cart.`;
        }
      }

      // Slot indicator steps
      slotSteps.forEach((step, idx) => {
        step.classList.toggle('filled', idx < count);
      });

      // Sticky Dock visibility
      if (dock) {
        dock.classList.toggle('is-visible', count > 0);
      }

      // Dock Slots
      dockSlots.forEach((slot, idx) => {
        const item = selectedItems[idx];
        const placeholder = slot.querySelector('.slot-placeholder');
        const thumbContainer = slot.querySelector('[data-slot-thumb-container]');
        const removeBtn = slot.querySelector('.slot-remove-btn');

        if (item) {
          slot.classList.add('filled');
          slot.classList.remove('empty');
          if (placeholder) placeholder.hidden = true;
          if (thumbContainer) {
            thumbContainer.replaceChildren();
            const img = document.createElement('img');
            img.className = 'slot-thumb';
            img.src = item.image;
            img.alt = item.title;
            img.width = 44;
            img.height = 44;
            img.loading = 'lazy';
            thumbContainer.append(img);
          }
          if (removeBtn) removeBtn.hidden = false;
        } else {
          slot.classList.remove('filled');
          slot.classList.add('empty');
          if (placeholder) placeholder.hidden = false;
          if (thumbContainer) {
            thumbContainer.replaceChildren();
          }
          if (removeBtn) removeBtn.hidden = true;
        }
      });

      // Price calculation
      const originalTotal = selectedItems.reduce((acc, curr) => acc + curr.price, 0);
      const isTargetReached = count >= targetCount;
      const discountAmount = isTargetReached ? Math.round(originalTotal * (discountPct / 100)) : 0;
      const finalTotal = originalTotal - discountAmount;

      if (originalPriceEl) {
        originalPriceEl.textContent = formatMoney(originalTotal);
        originalPriceEl.style.display = isTargetReached ? 'inline' : 'none';
      }

      if (finalPriceEl) {
        finalPriceEl.textContent = formatMoney(finalTotal);
      }

      if (savingsPill) {
        if (isTargetReached) {
          savingsPill.textContent = `Save ${formatMoney(discountAmount)} (${discountPct}% OFF)`;
          savingsPill.style.display = 'inline-block';
        } else {
          savingsPill.textContent = `Add ${targetCount - count} to save ${discountPct}%`;
          savingsPill.style.display = count > 0 ? 'inline-block' : 'none';
        }
      }

      // Submit Button state
      if (submitBtn) {
        submitBtn.disabled = !isTargetReached;
        if (submitBtnText) {
          if (isTargetReached) {
            submitBtnText.textContent = `Add Custom Trio to Cart • ${formatMoney(finalTotal)}`;
          } else {
            const needed = targetCount - count;
            submitBtnText.textContent = `Pick ${needed} More ${needed === 1 ? 'Item' : 'Items'} to Save ${discountPct}%`;
          }
        }
      }
    };

    // Variant select listener on bundle cards
    section.querySelectorAll('[data-bundle-variant-picker]').forEach((select) => {
      select.addEventListener('change', () => {
        const selectedOpt = select.options[select.selectedIndex];
        const card = select.closest('[data-bundle-card]');
        if (!card) return;

        const price = parseInt(selectedOpt.dataset.price, 10);
        const image = selectedOpt.dataset.image;
        const variantId = selectedOpt.value;

        const priceEl = card.querySelector('[data-bundle-card-price]');
        if (priceEl && selectedOpt.dataset.formattedPrice) {
          priceEl.textContent = selectedOpt.dataset.formattedPrice;
        }

        const toggleBtn = card.querySelector('[data-bundle-toggle]');
        if (toggleBtn) {
          toggleBtn.dataset.variantId = variantId;
          toggleBtn.dataset.price = price;
          if (image) toggleBtn.dataset.image = image;
        }

        // If card was already selected, update the item in selectedItems
        const existingIdx = selectedItems.findIndex((it) => it.productId === card.dataset.productId);
        if (existingIdx >= 0) {
          selectedItems[existingIdx].variantId = variantId;
          selectedItems[existingIdx].price = price;
          if (image) selectedItems[existingIdx].image = image;
          updateBundleUI();
        }
      });
    });

    // Toggle item in bundle
    section.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bundle-toggle]');
      if (!btn) return;

      const card = btn.closest('[data-bundle-card]');
      const productId = btn.dataset.productId;
      const variantId = btn.dataset.variantId;
      const price = parseInt(btn.dataset.price, 10) || 0;
      const title = btn.dataset.title;
      const image = btn.dataset.image || '';

      const existingIdx = selectedItems.findIndex((it) => it.productId === productId);

      if (existingIdx >= 0) {
        // Remove item
        selectedItems.splice(existingIdx, 1);
        if (card) {
          card.classList.remove('is-selected');
          const badge = card.querySelector('[data-checked-badge]');
          if (badge) badge.hidden = true;
          const label = card.querySelector('[data-toggle-label]');
          if (label) label.textContent = 'Add to Trio';
          btn.setAttribute('aria-pressed', 'false');
        }
      } else {
        // Add item
        if (selectedItems.length >= targetCount) {
          alert(`You can select up to ${targetCount} items for your custom bundle. Remove an item from your dock below to replace it.`);
          return;
        }
        selectedItems.push({ productId, variantId, price, title, image });
        if (card) {
          card.classList.add('is-selected');
          const badge = card.querySelector('[data-checked-badge]');
          if (badge) badge.hidden = false;
          const label = card.querySelector('[data-toggle-label]');
          if (label) label.textContent = '✓ In Trio (Remove)';
          btn.setAttribute('aria-pressed', 'true');
        }
      }

      updateBundleUI();
    });

    // Remove from dock slot directly
    dock?.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-slot-remove]');
      if (!removeBtn) return;

      const slotIdx = parseInt(removeBtn.dataset.slotRemove, 10);
      const itemToRemove = selectedItems[slotIdx];
      if (!itemToRemove) return;

      // Unselect matching card
      const card = section.querySelector(`[data-bundle-card][data-product-id="${itemToRemove.productId}"]`);
      if (card) {
        card.classList.remove('is-selected');
        const badge = card.querySelector('[data-checked-badge]');
        if (badge) badge.hidden = true;
        const toggleBtn = card.querySelector('[data-bundle-toggle]');
        if (toggleBtn) {
          const label = toggleBtn.querySelector('[data-toggle-label]');
          if (label) label.textContent = 'Add to Trio';
          toggleBtn.setAttribute('aria-pressed', 'false');
        }
      }

      selectedItems.splice(slotIdx, 1);
      updateBundleUI();
    });

    // Batch Add to Cart via Line Item Properties
    submitBtn?.addEventListener('click', async () => {
      if (selectedItems.length < targetCount || submitBtn.disabled) return;

      submitBtn.disabled = true;
      const originalText = submitBtnText ? submitBtnText.textContent : '';
      if (submitBtnText) submitBtnText.textContent = 'Adding Trio to Cart…';

      const bundleId = `canine_trio_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`;
      const payload = {
        items: selectedItems.map((item) => ({
          id: parseInt(item.variantId, 10),
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_tier: `Pick ${targetCount} & Save ${discountPct}%`,
            Bundle: `Canine Trio (${discountPct}% Off)`
          }
        }))
      };

      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!res.ok) throw new Error('Could not add bundle to cart');

        if (submitBtnText) submitBtnText.textContent = '✓ Trio Added to Cart!';

        // Refresh cart drawer and open it
        window.dispatchEvent(new CustomEvent('paws:cart:open'));

        setTimeout(() => {
          if (submitBtnText) submitBtnText.textContent = originalText;
          submitBtn.disabled = false;
        }, 1500);
      } catch (err) {
        console.error('Bundle add error:', err);
        alert('We were unable to add the bundle to your cart. Please try again or check availability.');
        submitBtn.disabled = false;
        if (submitBtnText) submitBtnText.textContent = originalText;
      }
    });

    updateBundleUI();
  };

  // 3. Decoupled Subscription UI Hook (Subscribe & Save)
  const initSubscriptionHook = () => {
    const container = document.querySelector('[data-subscription-container]');
    if (!container) return;

    const discountPct = parseInt(container.dataset.discountPct, 10) || 15;
    const choiceCards = container.querySelectorAll('[data-choice-card]');
    const toggles = container.querySelectorAll('[data-purchase-toggle]');
    const frequencyBox = container.querySelector('[data-frequency-box]');
    const frequencySelect = container.querySelector('[data-frequency-select]');
    const sellingPlanInput = container.querySelector('[data-selling-plan-input]');

    const onetimePriceEl = container.querySelector('[data-onetime-price-display]');
    const subPriceEl = container.querySelector('[data-subscription-price-display]');
    const subCompareEl = container.querySelector('[data-subscription-compare-display]');

    const pdpPriceContainer = document.querySelector('.product-price');
    const addToCartBtn = document.querySelector('.product-form .add-to-cart');
    const originalBtnText = addToCartBtn ? (addToCartBtn.textContent.trim() || 'Add to cart') : 'Add to cart';

    let currentPriceCents = parseInt(container.dataset.variantPrice, 10) || 0;
    let activeMode = 'onetime';

    // Strictly enforce "One-Time Purchase" as the initial default across all PDPs
    const onetimeRadio = container.querySelector('[data-purchase-toggle="onetime"]');
    const subRadio = container.querySelector('[data-purchase-toggle="subscription"]');
    if (onetimeRadio) onetimeRadio.checked = true;
    if (subRadio) subRadio.checked = false;

    choiceCards.forEach((card) => {
      const isOnetime = card.dataset.choiceCard === 'onetime';
      card.classList.toggle('active', isOnetime);
      card.setAttribute('aria-checked', isOnetime ? 'true' : 'false');
    });

    if (frequencyBox) {
      frequencyBox.hidden = true;
      frequencyBox.setAttribute('aria-hidden', 'true');
    }
    if (sellingPlanInput) {
      sellingPlanInput.disabled = true;
      sellingPlanInput.value = '';
    }

    const updatePrices = (priceCents) => {
      currentPriceCents = priceCents;
      const subPriceCents = Math.round(currentPriceCents * (1 - discountPct / 100));

      if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(currentPriceCents);
      if (subPriceEl) subPriceEl.textContent = formatMoney(subPriceCents);
      if (subCompareEl) subCompareEl.textContent = formatMoney(currentPriceCents);

      if (activeMode === 'subscription') {
        if (pdpPriceContainer) {
          const mainPriceSpan = pdpPriceContainer.querySelector('span:not(.price-note)');
          if (mainPriceSpan) mainPriceSpan.textContent = formatMoney(subPriceCents);
        }
        if (addToCartBtn && !addToCartBtn.disabled) {
          addToCartBtn.textContent = `Subscribe & Save ${discountPct}% • ${formatMoney(subPriceCents)}`;
        }
      } else {
        if (pdpPriceContainer) {
          const mainPriceSpan = pdpPriceContainer.querySelector('span:not(.price-note)');
          if (mainPriceSpan) mainPriceSpan.textContent = formatMoney(currentPriceCents);
        }
        if (addToCartBtn && !addToCartBtn.disabled) {
          addToCartBtn.textContent = originalBtnText;
        }
      }
    };

    toggles.forEach((radio) => {
      radio.addEventListener('change', () => {
        activeMode = radio.value;

        choiceCards.forEach((card) => {
          const isSelected = card.dataset.choiceCard === activeMode;
          card.classList.toggle('active', isSelected);
          card.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });

        if (activeMode === 'subscription') {
          if (frequencyBox) {
            frequencyBox.hidden = false;
            frequencyBox.setAttribute('aria-hidden', 'false');
          }
          if (sellingPlanInput) {
            sellingPlanInput.disabled = false;
            sellingPlanInput.value = frequencySelect ? frequencySelect.value : '';
          }
        } else {
          if (frequencyBox) {
            frequencyBox.hidden = true;
            frequencyBox.setAttribute('aria-hidden', 'true');
          }
          if (sellingPlanInput) {
            sellingPlanInput.disabled = true;
            sellingPlanInput.value = '';
          }
        }

        updatePrices(currentPriceCents);

        window.dispatchEvent(
          new CustomEvent('paws:subscription:change', {
            detail: {
              mode: activeMode,
              discountPct: discountPct,
              variantPrice: currentPriceCents,
              sellingPlanId: activeMode === 'subscription' && sellingPlanInput ? sellingPlanInput.value : null,
              frequency: frequencySelect ? frequencySelect.value : null
            }
          })
        );
      });
    });

    // Keyboard accessibility for card selection (Enter / Space)
    choiceCards.forEach((card) => {
      card.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          const radio = card.querySelector('[data-purchase-toggle]');
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });

    frequencySelect?.addEventListener('change', () => {
      if (sellingPlanInput && activeMode === 'subscription') {
        sellingPlanInput.value = frequencySelect.value;
      }
      window.dispatchEvent(
        new CustomEvent('paws:subscription:change', {
          detail: {
            mode: activeMode,
            discountPct: discountPct,
            variantPrice: currentPriceCents,
            sellingPlanId: sellingPlanInput ? sellingPlanInput.value : null,
            frequency: frequencySelect.value
          }
        })
      );
    });

    // Listen to variant changes from variant picker
    window.addEventListener('paws:variant:change', (e) => {
      if (e.detail && e.detail.price) {
        updatePrices(e.detail.price);
      }
    });

    // Initial calculation with zero layout shift
    updatePrices(currentPriceCents);
  };

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncementBar();
    initDogFitFinder();
    initCanineFitFilter();
    initBundleBuilder();
    initSubscriptionHook();
    // Start countdown timer
    if (document.querySelector('[data-countdown-end]')) {
      updateCountdown();
      setInterval(updateCountdown, 1000);
    }

    // Record recently viewed on product pages
    if (document.querySelector('[data-product-form]')) {
      const productTitle = document.querySelector('h1')?.textContent || '';
      const productImage = document.querySelector('#ProductMediaMain img')?.src || '';
      const productPrice = document.querySelector('.product-price span')?.textContent || '';
      const productForm = document.querySelector('[data-product-form]');
      const productId = productForm?.dataset.productId || '';
      const productUrl = productForm?.dataset.productUrl || '';

      if (productId) {
        addToRecentlyViewed(productId, productTitle, productImage, productPrice, productUrl);
      }
    }

    renderRecentlyViewed();
  });
})();
